export interface TrieNode {
  children: Record<string, TrieNode>;
  isEnd: boolean;
}

export class Trie {
  private root: TrieNode = { children: {}, isEnd: false };
  private wordCount = 0;

  insert(word: string): void {
    let node = this.root;
    for (const ch of word) {
      if (!node.children[ch]) {
        node.children[ch] = { children: {}, isEnd: false };
      }
      node = node.children[ch];
    }
    if (!node.isEnd) {
      node.isEnd = true;
      this.wordCount++;
    }
  }

  hasWord(word: string): boolean {
    let node = this.root;
    for (const ch of word) {
      if (!node.children[ch]) return false;
      node = node.children[ch];
    }
    return node.isEnd;
  }

  hasPrefix(prefix: string): boolean {
    let node = this.root;
    for (const ch of prefix) {
      if (!node.children[ch]) return false;
      node = node.children[ch];
    }
    return true;
  }

  getWordCount(): number {
    return this.wordCount;
  }

  getNode(prefix: string): TrieNode | null {
    let node = this.root;
    for (const ch of prefix) {
      if (!node.children[ch]) return null;
      node = node.children[ch];
    }
    return node;
  }

  /** Return root node for DFS traversal (O(1)). */
  getRoot(): TrieNode {
    return this.root;
  }

  /** Advance one step in the trie (O(1)); returns null if no edge exists. */
  static step(node: TrieNode, ch: string): TrieNode | null {
    return node.children[ch] ?? null;
  }
}
